
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 80 80"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#8B58FB","stroke-width":"6","d":"M40.75 29.5v21M16 50.13V42.5a4 4 0 014-4h40a4 4 0 014 4v7.63"}}),_c('rect',{attrs:{"width":"24","height":"24","x":"28","y":"10","fill":"#5929C1","rx":"8"}}),_c('rect',{attrs:{"width":"24","height":"24","x":"28","y":"46","fill":"#5929C1","rx":"8"}}),_c('rect',{attrs:{"width":"18","height":"18","x":"7","y":"49","fill":"#B99EF4","rx":"8"}}),_c('rect',{attrs:{"width":"18","height":"18","x":"55","y":"49","fill":"#B99EF4","rx":"8"}})])
          )
        }
      }
    